import { format, parse, parseISO } from 'date-fns'

export const formatDate = (date: string | null): string => {
  return date ? format(parseISO(date), 'dd/MM/yyyy') : '-'
}

export const dateTimeParser = (
  dateString: string,
): { [key: string]: string } => {
  const date = parse(dateString, 'dd/MM/yyyy HH:mm:ss', new Date())
  const formattedDate = format(date, 'dd/MM/yyyy')
  const formattedTime = format(date, 'HH:mm:ss')

  return {
    date: formattedDate,
    time: formattedTime,
  }
}

export const dateTimeParserwithoutSeconds = (
  dateString: string,
): { [key: string]: string } => {
  const date = parse(dateString, 'dd/MM/yyyy HH:mm', new Date())
  const formattedDate = format(date, 'dd/MM/yyyy')
  const formattedTime = format(date, 'HH:mm')

  return {
    date: formattedDate,
    time: formattedTime,
  }
}

export function isEqualDateNow(compareDate: string): boolean {
  return (
    Number(formatDate(compareDate).split('/').join('')) ===
    Number(format(new Date(), 'ddMMyyyy'))
  )
}

export function isEqualDate(date1: string, date2: string): boolean {
  return (
    Number(formatDate(date1).split('/').join('')) ===
    Number(formatDate(date2).split('/').join(''))
  )
}

export function isValidDate(date: Date): boolean {
  if (date) {
    const timeDate = date.getTime()
    return !isNaN(timeDate)
  }
}
